import { useContext } from 'react';
import { AuthContext } from './context';
import type { AuthContextValue } from './types';

/** Access the current auth session. Must be used inside <AuthProvider>. */
export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an <AuthProvider>.');
  }
  return context;
}
